<template>

    <form ref="instituicaoensinopoliticacomercial-form-edit" v-on:submit.prevent="executeEdit(model)" novalidate>

        <div class="row">


            <div class="form-group col-md-6">
                <input type="hidden" v-bind:value="model.InstituicaoEnsinoId" id="instituicaoEnsinoId" name="nstituicaoEnsinoId" />
                <label for="instituicaoEnsinoId">Instituicao Ensino</label>
                <p><b>{{model.instituicaoEnsinoPoliticaComercial.instituicaoEnsino.empresa.pessoaEscola.nome}}</b></p>
                <!--<input type="text" class="form-control" name="instituicaoEnsinoNome"  v-model="model.instituicaoEnsinoPoliticaComercial.instituicaoEnsino.empresa.pessoaEscola.nome"  disabled />-->
            </div>
            <div class="form-group col-md-6">
                <label for="titulo">Título</label>
                <input type="text" class="form-control" name="titulo" placeholder="Título" v-model="model.instituicaoEnsinoPoliticaComercial.titulo" required />
            </div>


        </div>
        <div class="row">


            <div class="table-responsive standard-table">
                <table>
                    <thead style="background-color:red">
                        <tr>
                            <th>Estágio</th>
                            <th>Produto</th>
                            <th>Valor - Instituição</th>
                            <th>Valor - Aluno</th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in model.collectionEstoqueItemEstagio" v-bind:key="item.tagJobsId">
                            <td>{{ item.nomeEstagio }}</td>
                            <td>{{ item.nomeMaterial }}</td>
                            <td><input type="text" class="form-control valor" v-on:change="valorInstituicao"  v-bind:data-estoqueItemId="item.estoqueItemId" data-value="valorInstituicaoEnsino" :id="'inst'+item.estoqueItemId" v-bind:value="item.valorInstituicaoEnsino" /></td>
                            <td><input type="text" class="form-control valor" v-on:change="valorAluno"  v-bind:data-estoqueItemId="item.estoqueItemId" data-value="valorAluno" :id="'aluno'+item.estoqueItemId" v-bind:value="item.valorAluno" /></td>

                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeEdit(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensinopoliticacomercial-form-edit",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {
                instituicaoEnsinoPoliticaComercial: {
                    instituicaoEnsino: {
                        empresa: {
                            pessoaEscola: {
                                escola: {},
                            },
                        },
                    },
                    collectionProdutoPoliticaComercialPreco: {},
                },
                collectionEstoqueItemEstagio: {},
            },
            form: "instituicaoensinopoliticacomercial-form-edit",

            resources: {
                edit: 'instituicaoensinopoliticacomercial',
            },

        }),

        methods: {
            valorAluno: function (val, oldVal) {
     
                this.model.collectionEstoqueItemEstagio.filter((teste) => {
                    if (teste.estoqueItemId == val.target.attributes[1].value) {
                        teste.valorAluno = val.target.value
                    }

                });
            },
            valorInstituicao: function (val, oldVal) {
      
                this.model.collectionEstoqueItemEstagio.filter((teste) => {
                    if (teste.estoqueItemId == val.target.attributes[1].value) {
                        teste.valorInstituicaoEnsino = val.target.value

                        if (teste.produtoPoliticaComercialPrecoId == null)
                            teste.produtoPoliticaComercialPrecoId = 0

                        if (teste.instituicaoEnsinoPoliticaComercialId == null)
                            teste.instituicaoEnsinoPoliticaComercialId = 0


                    }
                });
            },
            executeEdit: function (model) {


                if (this.formValidate() == false) return;


                var listaProdutoPoliticaComercialPreco = model.collectionEstoqueItemEstagio.filter((teste) => {

                    return teste.valorInstituicaoEnsino != null || teste.valorAluno != null;

                });

                for (var i = 0; i < listaProdutoPoliticaComercialPreco.length; i++) {
                    delete listaProdutoPoliticaComercialPreco[i].nomeEstagio;
                    delete listaProdutoPoliticaComercialPreco[i].nomeMaterial;
                }

                var InstituicaoEnsinoPoliticaComercialDtoSave = {
                    instituicaoEnsinoPoliticaComercialId: this.model.instituicaoEnsinoPoliticaComercial.instituicaoEnsinoPoliticaComercialId,
                    instituicaoEnsinoId: this.model.instituicaoEnsinoPoliticaComercial.instituicaoEnsinoId,
                    titulo: this.model.instituicaoEnsinoPoliticaComercial.titulo,
                    collectionProdutoPoliticaComercialPreco: listaProdutoPoliticaComercialPreco
                };
                console.log(InstituicaoEnsinoPoliticaComercialDtoSave);
                new Api(this.resources.edit).post(InstituicaoEnsinoPoliticaComercialDtoSave).then(data => {
                    this.defaultSuccessResult("Edição realizada com sucesso");
                    this.$emit('on-saved')
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },

        mounted() {
            new Api('InstituicaoEnsinoPoliticaComercial/PoliticaComercial').get({ instituicaoEnsinoId: this.id }).then(data => {
                if (data.data) {
                    console.log('entreiiaaaaaaaaaai', data.data)
                    this.model = data.data;
                    console.log('entreiii', model)
                }
                else if (!data) this.model = {};
                else if (data.length == 1) this.model = data[0];
                else this.model = {};
            }, err => {
                this.defaultErrorResult(err);
            })
        }
    };
</script>